// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__WeRN0","spout":"Tag_spout__ou8Wy"};